module.exports = __webpack_public_path__ + "images/honda_small910a8616504c53f14686d215a3f8b415.png";